/**
 * The paper's row order inside a section, shared by the unified input
 * (`spreadsheet-model.ts`) and the record view / print / phone document
 * (`components/production/record-insights.ts`), so the screen Marsha types
 * into and the record she signed list the same items in the same order
 * (Amana, 2026-11-04: the edit screen read broccoli, oranges, milk while the
 * saved record read milk, milk, broccoli, oranges). Pure.
 */

/** The paper's kind order (Main, Grain, Vegetable, Fruit, Milk/Beverage, Side, Condiment); unknown last. */
const KIND_RANK: Record<string, number> = {
  MAIN_ENTREE: 0,
  GRAIN: 1,
  VEGETABLE: 2,
  FRUIT: 3,
  BEVERAGE: 4,
  SIDE: 5,
  CONDIMENT: 6,
  SUPPLEMENT: 7,
}

export const UNKNOWN_KIND_RANK = 8

export function kindRank(kind: string | null | undefined): number {
  return kind ? (KIND_RANK[kind] ?? UNKNOWN_KIND_RANK) : UNKNOWN_KIND_RANK
}

/** A row's rank: its lowest-ranked kind (a kit ranks as its main); no known kind ranks last. */
export function rowKindRank(kinds: ReadonlyArray<string | null | undefined>): number {
  return Math.min(UNKNOWN_KIND_RANK, ...kinds.map(kindRank))
}

/** Kind rank first, then the name (numeric-aware). */
export function compareByKindThenName(
  a: { sortRank: number; name: string },
  b: { sortRank: number; name: string },
): number {
  return a.sortRank - b.sortRank || a.name.localeCompare(b.name, undefined, { numeric: true })
}
